<template>
  <div
    class="sb-options"
    data-sb-regression="sb-options"
  >
    <template v-if="hasOptionDefaultSlot">
      <!-- @slot slot to render options text -->
      <slot
        v-for="option in options"
        :option="option"
      />
    </template>
    <slot v-else />
  </div>
</template>

<script>

/**
 * Helper component to be used inside sb-dropdown
 */
export default {
  name: 'SbOptions',
  inject: {
    SbSelect: {},
  },
  computed: {
    hasOptionDefaultSlot() {
      return this.$slots.default && this.$slots.default();
    },
    options() {
      return this.SbSelect.options;
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@src/components/Dropdown/style/sb-options.scss';
</style>
